import { render, staticRenderFns } from "./methanolIndustrial.vue?vue&type=template&id=570193a8&scoped=true&"
import script from "./methanolIndustrial.vue?vue&type=script&lang=js&"
export * from "./methanolIndustrial.vue?vue&type=script&lang=js&"
import style0 from "./methanolIndustrial.vue?vue&type=style&index=0&id=570193a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570193a8",
  null
  
)

export default component.exports